export const CUSTOMER_STATUS = {
  active: { label: 'Active', value: 'active' },
  inactive: { label: 'Inactive', value: 'inactive' },
};

export const CUSTOMER_STATUSES = Object.values(CUSTOMER_STATUS);
